export default "__VITE_ASSET__vwCIlN0o__"